<template>
  <div>
    <div class="header">
      <a class="hamburger"><i class="fas fa-bars"></i></a>
      <div class="in_mobile">
        <div class="brand inline d-none d-lg-block d-xl-block">
          <router-link :to="{ name: 'dashboard.index' }" v-if="company_logo != '' && company_logo_exist == 1">
            <img :src="company_logo" class="logo_c" alt="logo" :data-src="company_logo" @error="handleLogoError"/>
          </router-link>
          <router-link :to="{ name: 'dashboard.index' }" v-if="company_logo == '' && company_logo_exist == 0">
            <img src="/static/img/logo.svg" class="logo_w" alt="logo" data-src="/static/img/logo.svg"/>
          </router-link>
        </div>
      </div>
      <div class="mode_alert m-auto" v-if="liveOrDemoStatus">
        Your account is in DEMO mode. To activate LIVE mode please contact your
        customer success manager.
      </div>
      <div class="d-flex align-items-center">
        <div v-if="showOrNot === 2" style="white-space: nowrap">
          <div
            class="form-check form-check-inline success radioborder mr-2"
            :class="{ active: liveOrDemo == 'demo' }"
          >
            <input
              type="radio"
              name="state"
              id="demo"
              value="demo"
              v-model="liveOrDemo"
              @change="showLiveOrDemo"
            />
            <label for="demo" class="m-0">Demo</label>
          </div>
          &nbsp;
          <div
            class="form-check form-check-inline success radioborder mr-3"
            :class="{ active: liveOrDemo == 'live' }"
          >
            <input
              type="radio"
              name="state"
              id="live"
              value="live"
              v-model="liveOrDemo"
              @change="showLiveOrDemo"
            />
            <label for="live" class="m-0">Live</label>
          </div>
        </div>
        <span
          v-if="this.currentURL == '/'"
          title="Quick Start Guide"
          class="header_icon btn-icon-link"
          data-target="#quickviewa"
          data-toggle="modal"
        >
          <i class="fas fa-rocket"></i>
        </span>
        <span
          id="intro_siderbar"
          @click="startWalkthrough"
          class="header_icon btn-icon-link"
          title="Home screen menus walkthrough."
        >
          <i
            data-placement="bottom"
            class="fas fa-running"
            aria-hidden="true"
          ></i>
        </span>
        <span v-if="!isHelpIconHidden($route.path)"
          class="header_icon btn-icon-link"
          id="faq-btn"
          data-target="#help"
          data-toggle="modal"
          data-step="10"
          data-intro="Click here at any page to get your FAQs answered."
          data-position="bottom"
          title="Contextual Help & FAQs."
        >
          <i class="far fa-question-circle"></i>
        </span>
        <span class="theme_change btn-icon-link" style="display: none">
          <i class="fas fa-sun"></i><i class="far fa-moon"></i>
        </span>
        <!--
          Configuration alerts. Hides itself entirely when the feature is off for
          the company or when there is nothing wrong — see the component and
          docs/SYSTEM_CONFIG_ALERTS.md §3.6.
        -->
        <system-alert-bell></system-alert-bell>
        <!--
          Product Updates bell — hidden for now, frontend only. Nothing behind it
          has been touched: the list still loads and the routes still work, so
          taking this comment out puts it straight back.
        -->
        <!--
        <div
          class="dropdown notificationicoblock"
          v-if="notificationList.length"
        >
          <span
            class="notificationico pointer header_icon"
            title="Product Updates"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            aria-label="profile dropdown"
          >
            <i class="far fa-bell"></i>
            <span class="notification_count" v-if="notificationCount > 0">{{
              notificationCount
            }}</span>
          </span>
          <ul class="dropdown-menu dropdown-menu-right mt10" role="menu">
            <li
              class="viewallNotify text-right"
              @click="goToNotification(null)"
            >
              <span>View all</span>
            </li>
            <li v-for="notification in notificationList" :key="notification.id">
              <div
                class="notificationClick"
                @click="goToNotification(notification.id)"
                :class="{ opned: notification.is_read }"
              >
                <h6 class="fs-14 bold m-0 lh_18">{{ notification.name }}</h6>
                <small class="opacity-75 block">{{
                  notification.created_at
                }}</small>
              </div>
            </li>
          </ul>
        </div>
        -->
        <div class="dropdown pull-right d-lg-block">
          <button
            class="profile-dropdown-toggle logindetail_p"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            aria-label="profile dropdown"
          >
            <!-- v-if on the wrapper: currentUser is null for a session whose localStorage
                 record is gone, and every read in here dereferenced it unguarded. The redirect
                 to login in beforeMount is async, so this still renders once on the way out. -->
            <div class="logindetail" v-if="currentUser">
              <span>
                {{ titleCase(currentUser.first_name) }}
                <strong v-if="currentUser.last_name">
                  {{ titleCase(currentUser.last_name) }}
                </strong>
              </span>
              <span>({{ currentUser.company }})</span>
            </div>
            <span class="thumbnail-wrapper d32 circular inline">
              <img
                src="/static/img/dummy_user.png"
                alt=""
                data-src="/static/img/dummy_user.png"
                width="32"
                height="32"
              />
            </span>
          </button>
          <ul
            class="dropdown-menu dropdown-menu-right profile-dropdown"
            role="menu"
          >
            <li v-if="permissions.general">
              <router-link :to="{ name: 'general' }" class="m-t-10">
                <i class="pg-settings_small"></i> Settings
              </router-link>
            </li>
            <li v-if="status && status == 2 && company_id != selected_company">
              <a href="#" @click="updateAdminLogin"
                ><i class="pg-outdent"></i> Login As Admin</a
              >
            </li>
            <li class="bg-master-lighter" @click="logoutUser">
              <a class="clearfix pointer">
                <span class="pull-left">Logout</span>
                <span class="pull-right"
                  ><i class="pg-power" style="padding: 11px"></i
                ></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      v-bind:class="
        quickmenu + ' quickview-wrapper builder hidden-sm hidden-xs'
      "
      id="builder"
      v-if="
        managementReportQuickBtnpermissions.vulnerability_trend_new ||
        managementReportQuickBtnpermissions.awareness_trend_new ||
        managementReportQuickBtnpermissions.reporting_trend_new ||
        managementReportQuickBtnpermissions.weakest_links_new ||
        managementReportQuickBtnpermissions.strongest_links_least_compromised_new ||
        managementReportQuickBtnpermissions.strongest_links_most_compromised_new ||
        managementReportQuickBtnpermissions.weakest_departments_new
      "
    >
      <a
        class="builder-close"
        @click="quickview()"
        data-toggle="quickview"
        data-toggle-element="#builder"
        ><i class="fas fa-times"></i
      ></a>
      <a
        id="quickview-btn"
        data-intro="Management Level Reporting of your data. Get easy answers."
        data-position="left"
        class="builder-toggle"
        @click="quickview()"
        data-toggle="quickview"
        data-toggle-element="#builder"
        title="Management Report"
      >
        <i class="far fa-file-pdf"></i>
      </a>
      <h4 class="filters_h_tag">Management Report</h4>
      <div class="filter_slide_popup">
        <ol class="report_link_list">
          <router-link
            tag="li"
            v-if="managementReportQuickBtnpermissions.vulnerability_trend_new"
            :to="{ name: 'managementreport.phishingvulnerabilitytrend' }"
          >
            <a
              v-bind:class="{
                active:
                  currentRouteName ==
                  'managementreport.phishingvulnerabilitytrend',
              }"
            >
              What does our Phishing Vulnerability trend look like?</a
            >
          </router-link>
          <router-link
            tag="li"
            v-if="managementReportQuickBtnpermissions.awareness_trend_new"
            :to="{ name: 'managementreport.cybersecurityawarenesstrend' }"
          >
            <a
              v-bind:class="{
                active:
                  currentRouteName ==
                  'managementreport.cybersecurityawarenesstrend',
              }"
              >What does our Awareness Trend look like?</a
            >
          </router-link>
          <router-link
            tag="li"
            v-if="managementReportQuickBtnpermissions.reporting_trend_new"
            :to="{ name: 'managementreport.phishingreportingtrend' }"
          >
            <a
              v-bind:class="{
                active:
                  currentRouteName == 'managementreport.phishingreportingtrend',
              }"
              >What does our Reporting trend look like?</a
            >
          </router-link>
          <router-link
            tag="li"
            v-if="managementReportQuickBtnpermissions.weakest_links_new"
            :to="{ name: 'managementreport.weakestlinks' }"
          >
            <a
              v-bind:class="{
                active: currentRouteName == 'managementreport.weakestlinks',
              }"
              >Who are our weakest links?</a
            >
          </router-link>
          <router-link
            tag="li"
            v-if="
              managementReportQuickBtnpermissions.strongest_links_least_compromised_new
            "
            :to="{ name: 'managementreport.strongestlinks-least-compromised' }"
          >
            <a
              v-bind:class="{
                active:
                  currentRouteName ==
                  'managementreport.strongestlinks-least-compromised',
              }"
              >Who are our strongest links? (Least Compromised)</a
            >
          </router-link>
          <router-link
            tag="li"
            v-if="
              managementReportQuickBtnpermissions.strongest_links_most_compromised_new
            "
            :to="{ name: 'managementreport.strongestlinks-most-reported' }"
          >
            <a
              v-bind:class="{
                active: currentRouteName == 'strongestlinks-most-reported',
              }"
              >Who are our strongest links? (Most Reported)</a
            >
          </router-link>
          <router-link
            tag="li"
            v-if="managementReportQuickBtnpermissions.weakest_departments_new"
            :to="{ name: 'managementreport.weakestdepartments' }"
          >
            <a
              v-bind:class="{
                active:
                  currentRouteName == 'managementreport.weakestdepartments',
              }"
              >Which of our departments are the weakest?</a
            >
          </router-link>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { routes as recipient_routes } from "../../app/recipient";
import { routes as report_routes } from "../../app/report";
import { routes as gamification_routes } from "../../app/gamification";
import { routes as managementreport_routes } from "../../app/managementreport";
import { routes as vcro_routes } from "../../app/vcro";
import { routes as setting_routes } from "../../app/setting";
import { routes as leaderboard_routes } from "../../app/leaderboard";
import { routes as laggards_routes} from "../../app/laggards"
import { routes as userportalpages_routes} from "../../app/userportalpages"
import { routes as ip_routes} from "../../app/ip"
import SystemAlertBell from "./system_alert_bell"
import { readStoredUser } from "utils/storedUser"

export default {
  components: {
    // Static import, not import(): this project's babel preset is stage-2 with
    // no syntax-dynamic-import plugin, so import() is a parse error here. The
    // navbar loads on every page anyway, so there is nothing to defer.
    SystemAlertBell,
  },
  computed: {
    ...mapGetters(["currentUser", "routesEmpty", "helpIconRoutes"]),
  },
  props: [
    "type",
    "routeHeader",
    "routePath",
    "modifyData",
    "refreshCampaignComponent",
    "suborg",
  ],
  data() {
    return {
      liveOrDemoStatus: false,
      liveOrDemo: "",
      showOrNot: 0,
      company_logo: "",
      company_logo_exist: 2,
      status: "",
      selected_company: "",
      company_id: "",
      permissions: {
        general: true,
      },
      remaining_days: "",
      quickmenu: "",
      activemenu: "text-complete",
      currentRouteName: "",
      helpUrl: [
        { message: "report/campaigns" },
        { message: "/" },
        { message: "/campaigns" },
        { message: "/announcements" },
        { message: "/announcements/create" },
        { message: "/campaigns/description/" },
        { message: "/campaigns/create" },
      ],
      managementReportQuickBtnpermissions: {
        vulnerability_trend_new: true,
        awareness_trend_new: true,
        reporting_trend_new: true,
        weakest_links_new: true,
        strongest_links_least_compromised_new: true,
        strongest_links_most_compromised_new: true,
        weakest_departments_new: true,
      },
      steps: [],
      walkthroughSteps: {
        dashboard: {
          elementId: "#sidebar-dashboard",
          intro: "Get a bird’s eye view of all important metrics.",
          position: "right",
        },
        calendar: {
          elementId: "#sidebar-calendar",
          intro: "View and export schedule calendar.",
          position: "right",
        },
        campaigns: {
          elementId: "#sidebar-campaign",
          intro: "Create and manage phishing campaigns.",
          position: "right",
        },
        announcements: {
          elementId: "#sidebar-announcement",
          intro:
            "Use this to create and manage announcements, eAUP, or internal communication.",
          position: "right",
        },
        policy: {
          elementId: "#sidebar-policy",
          intro:
            "Create and Manage Policy.",
          position: "right",
        },
        adobe_acrobat: {
          elementId: "#adobe_acrobat",
          intro: "View and manage Adobe Acrobat.",
          position: "right",
        },
        scenarios: {
          elementId: "#sidebar-scenario",
          intro:
            "Create and manage scenarios for phishing,announcement campaigns and policy.",
          position: "right",
        },
        trainings: {
          elementId: "#sidebar-training",
          intro: "Upload, view and manage cybersecurity training modules.",
          position: "right",
        },
        lms: {
          elementId: "#sidebar-lms",
          intro:
            "View and manage cybersecurity training enrolments and reports.",
          position: "right",
        },
        recipients: {
          elementId: "#sidebar-recipients",
          intro: "View and manage recipients here.",
          position: "right",
        },
        reports: {
          elementId: "#sidebar-reports",
          intro: "View all the old and legacy reports here.",
          position: "right",
        },
        reportsnew: {
          elementId: "#sidebar-reports-new",
          intro: "View the new enhanced reports here.",
          position: "right",
        },
        newmanagement_reports: {
          elementId: "#sidebar-management-reports",
          intro: "Quick access to important management reports.",
          position: "right",
        },
        newvulnerability_reports: {
          elementId: "#sidebar-vulnerability-reports",
          intro:
            "Uncover the most vulnerable departments and designations in your organisation.",
          position: "right",
        },
        vcronew: {
          elementId: "#sidebar-vcro",
          intro:
            "Uncover and protect the most critical and vulnerable resources with the help of your own Virtual Cyber Risk Officer.",
          position: "right",
        },
        newgamification_engine: {
          elementId: "#sidebar-gamification",
          intro:
            "Increase employee engagement in cybersecurity initiatives through gamification.",
          position: "right",
        },
        user_portal_new: {
          elementId: "#sidebar-user-portal",
          intro:
            "Empower your employees by giving them access to their complete cybersecurity profile through User Portal.",
          position: "right",
        },
        exported_files: {
          elementId: "#exported_files",
          intro: "Exported Files",
          position: "right",
        },
        teamportal: {
          elementId: "#teamportal",
          intro: "Access and manage the Team Portal.",
          position: "right",
        },
        admin_log: {
          elementId: "#admin_log",
          intro: "View the log of user activity.",
          position: "right",
        },
        settings: {
          elementId: "#sidebar-settings",
          intro: "Manage all common platform settings from here.",
          position: "right",
        },
        ip_information: {
          elementId: "#ip_information",
          intro: "View and manage user IP information.",
          position: "right",
        },
        active_directory: {
          elementId: "#active_directory_nav",
          intro: "Manage Active Directory settings here.",
          position: "right",
        },
        azure_active_dir: {
          elementId: "#sidebar-azure-active-dir",
          intro: "Manage Azure AD settings here.",
          position: "right",
        },
        faq: {
          elementId: "#faq-btn",
          intro:
            "Click this to get contextual help and answers to frequently asked questions.",
          position: "right",
        },
        quickview: {
          elementId: "#quickview-btn",
          intro: "Quick access to management level reports.",
          position: "right",
        },
      },
      helps_route: [],
      notificationList: [],
      notificationCount: {},
    };
  },
  created() {
    let local = JSON.parse(localStorage.getItem("company_logo"));
    if (!local || local === null) {
      this.$http.get("/setting/company_logo").then((response) => {
        localStorage.setItem(
          "company_logo",
          JSON.stringify(response.data.data)
        );
        this.company_logo = response.data.data.logo;
         const educateDomainUrl = response.data.data.active_educate_domain_url;
        const activeDomainUrl = Object.keys(educateDomainUrl).find(key => educateDomainUrl[key] === true);
        const fullDomain = `https://${activeDomainUrl}`;
        localStorage.setItem('activeEducationDomain', fullDomain);
        if (response.data.data.active_pdf_campaign) {
          const isActive = response.data.data.active_pdf_campaign.is_active_pdf_campaign;
          const existingValue = JSON.parse(localStorage.getItem("pdfCampaignSetting"));
          if (existingValue === null || existingValue !== isActive) {
            localStorage.setItem("pdfCampaignSetting", JSON.stringify(isActive));
          }
        }
      });
    }
    if (this.routesEmpty) this.createRouteSet();
    let permissions = JSON.parse(localStorage.getItem("permissions"));
    this.managementReportQuickBtnpermissions = {
      vulnerability_trend_new:
        permissions && permissions.vulnerability_trend_new,
      awareness_trend_new: permissions && permissions.awareness_trend_new,
      reporting_trend_new: permissions && permissions.reporting_trend_new,
      weakest_links_new: permissions && permissions.weakest_links_new,
      strongest_links_least_compromised_new:
        permissions && permissions.strongest_links_least_compromised_new,
      strongest_links_most_compromised_new:
        permissions && permissions.strongest_links_most_compromised_new,
      weakest_departments_new:
        permissions && permissions.weakest_departments_new,
    };
    $(document).ready(function () {
      $(document).on(
        "click",
        ".introjs-skipbutton, .introjs-donebutton, .introjs-overlay",
        function (e) {
          e.preventDefault();
          $(".page-sidebar").removeClass("active_sidebar");
        }
      );
    });
    this.$bus.$on("updateCompanyLogo", (updatedLogo) => {
      this.company_logo = updatedLogo;
    });
  },
  beforeMount() {
    // Was `JSON.parse(localStorage.getItem("user"))` read straight into `.first_time` below.
    // When the key is absent that parse yields null and the property read threw, which aborted
    // this whole hook — including the `if (!this.currentUser)` redirect at the end of it, the
    // one thing that would have recovered the session. The crash was suppressing its own fix.
    let logindata = readStoredUser();
    let quickStart = localStorage.getItem("quickStart");
    if (!JSON.parse(localStorage.getItem("permissions"))) {
      this.$http.get("/setting/user_modules").then((response) => {
        this.showOrNot = response.data.data.status;
        this.accountType();
      });
    } else {
      let user_permission = JSON.parse(localStorage.getItem("permissions"));
      this.showOrNot = user_permission.status;
      this.accountType();
    }
    if (logindata && logindata.first_time) {
      if (quickStart == 1) {
        setTimeout(() => {
          $("#quickviewa").modal("show");
          localStorage.removeItem("quickStart");
          // $(".page-sidebar").addClass('active_sidebar');
          // 	introJs(100).setOption({'scrollToElement':true,'showProgress':true}).start();
        }, 3500);
      }
    }
    var currentURL = window.location.pathname;
    this.currentURL = currentURL;
    let permissions = JSON.parse(localStorage.getItem("permissions"));
    if (permissions) {
      this.permissions.general = permissions.general;
    }


    this.remaining_days = JSON.parse(localStorage.getItem("expired_in"));
    if (!this.currentUser) {
      this.$router.push({ name: "auth.login" });
    }
    this.currentRouteName = this.$router.currentRoute.name;

    this.companyLogo();
  },
  mounted() {
    this.getNotificationList();
  },
  methods: {
    /**
     * Makes logout() action available withint this component
     * See /src/app/auth/vuex/actions.js
     */
    ...mapActions(["logout", "setHelpIconRoutes"]),
    /**
     * Fall back to the default HumanFirewall logo when the company logo
     * URL fails to load (missing/broken upload) so the header never shows
     * a broken-image icon.
     */
    handleLogoError() {
      this.company_logo = "";
      this.company_logo_exist = 0;
    },
    /**
     * "john" -> "John". Was duplicated inline in the template for first and last name, where an
     * absent value meant .charAt() on undefined and a render crash.
     */
    titleCase(value) {
      if (!value) {
        return "";
      }
      return String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase();
    },
    /* eslint-disable no-undef */
    companyLogo() {
      let companyLogoData = JSON.parse(localStorage.getItem("company_logo"));
      // company_logo may be absent (e.g. fresh login flows never set it) —
      // bail out instead of throwing in beforeMount, which would abort the
      // whole page mount and block the underlying view from loading.
      if (!companyLogoData) {
        return;
      }
      this.company_logo_exist = 1;
      this.company_logo = companyLogoData.logo;
      this.company_id = companyLogoData.company_id;
      this.status = companyLogoData.status;
      this.selected_company = companyLogoData.selected_company;
    },

    accountType() {
      let account_type = localStorage.getItem("account-type");
      if (parseInt(this.showOrNot) === 2 && account_type == null) {
        this.getLiveOrDemoStatus();
      } else {
        this.liveOrDemo = account_type;
        this.activeCheck();
      }
    },
    changeTypeLiveDemo() {
      this.$http
        .post("/adminlogin/switch-account-type", {
          account_type: this.liveOrDemo,
        })
        .then((response) => {
          if (response.data.status) {
            if (this.liveOrDemo === "demo") {
              this.liveOrDemoStatus = true;
            } else {
              this.liveOrDemoStatus = false;
            }
            $("body")
              .pgNotification({
                message: response.data.message,
                position: "top",
                style: "bar",
                timeout: 4000,
                type: "success",
              })
              .show();
          } else {
            $("body")
              .pgNotification({
                message: response.data.message,
                position: "top",
                style: "bar",
                timeout: 4000,
                type: "error",
              })
              .show();
            this.changeStatusFailed();
          }
          this.setliveDemoStatus();
        });
    },
    showLiveOrDemo() {
      let note =
        "Switching to DEMO mode means the client will only see demo data.";
      if (this.liveOrDemo === "live") {
        note = "Switch to LIVE mode for full access and functionality.";
      }
      this.$swal({
        title: `You're about to switch ${this.currentUser.company} to ${this.liveOrDemo} mode.`,
        text: note,
        type: "warning",
        class: "swal-color",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Switch",
      })
        .then(
          function (confirm) {
            if (confirm) {
              this.changeTypeLiveDemo();
            }
          }.bind(this)
        )
        .catch(() => {
          this.changeStatusFailed();
        });
    },

    changeStatusFailed() {
      if (this.liveOrDemo === "demo") {
        this.liveOrDemo = "live";
        this.liveOrDemoStatus = false;
      } else {
        this.liveOrDemo = "demo";
        this.liveOrDemoStatus = true;
      }
    },
    getLiveOrDemoStatus() {
      this.$http.get("/adminlogin/account-type").then((response) => {
        if (response.data.status) {
          this.liveOrDemo = response.data.account_type;
          this.setliveDemoStatus();
          this.activeCheck();
        }
      });
    },
    setliveDemoStatus() {
      localStorage.setItem("account-type", this.liveOrDemo);
    },
    activeCheck() {
      if (this.liveOrDemo === "demo") {
        this.liveOrDemoStatus = true;
      } else {
        this.liveOrDemoStatus = false;
      }
    },
    getNotificationList() {
      this.$http.get("/setting/company-notifications").then((response) => {
        this.notificationList = response.data.data;
        this.notificationCount = response.data.meta.unreadCount;
      });
    },
    postNotificationList(id) {
      this.$http
        .post(
          `/setting/company-notifications-user-relations?company_notification_id=${id}`
        )
        .then((response) => {
          this.notificationList = response.data;
          this.getNotificationList();
        });
    },
    goToNotification(notificationId) {
      if (notificationId !== null) {
        this.postNotificationList(notificationId);
        this.$router.push({
          name: "notificationDescription",
          params: { id: notificationId },
        });
      } else {
        this.$router.push({
          name: "notificationDescription",
          params: { id: "all" },
        });
      }
    },
    logoutUser() {
      this.logout();
      localStorage.clear();
      this.$router.push({ name: "auth.login", query: { logout: true } });
    },
    updateAdminLogin() {
      var data = {};
      data.admin_company_id = this.company_id;
      this.$http.post("/adminlogin/updateadminlogin", data).then((response) => {
        if (response.data) {
          location.reload();
        }
      });
    },
    quickview() {
      if (this.quickmenu == "open") {
        this.quickmenu = "";
      } else {
        this.quickmenu = "open";
      }
    },
    startWalkthrough() {
      this.steps = [];
      let sidebar_permissions = JSON.parse(
        localStorage.getItem("s_permissions")
      );
      Object.keys(sidebar_permissions).map((i) => {
        if (sidebar_permissions[i] && this.walkthroughSteps[i]) {
          this.walkthroughSteps[i].element = document.querySelector(
            this.walkthroughSteps[i].elementId
          );
          if (this.walkthroughSteps[i].element)
            this.steps.push(this.walkthroughSteps[i]);
        }
      });
      $(".page-sidebar").addClass("active_sidebar");
      $(".page-container").addClass("stop-scrolling");
      introJs()
        .setOptions({
          showProgress: true,
          steps: this.steps,
        })
        .start()
        .onbeforechange(function (targetElement) {
          if (!targetElement)
            // if targetElement does not exist
            introJS().nextStep(); // go to the next step
        })
        .onbeforeexit(function () {
          $(".page-sidebar").removeClass("active_sidebar");
          $(".page-container").removeClass("stop-scrolling");
          return;
        });
    },
    isHelpIconHidden(currentPath) {
      let basePath = currentPath.split('/').slice(0, 3).join('/');
      // Check if the basePath exists in helps_route
      return this.helpIconRoutes.includes(basePath);
    },
    createRouteSet() {
      let routes = [
        ...recipient_routes,
        ...report_routes,
        ...gamification_routes,
        ...managementreport_routes,
        ...vcro_routes,
        ...setting_routes,
        ...leaderboard_routes,
        ...laggards_routes,
        ...userportalpages_routes,
        ...ip_routes
      ];
      let helps_route = [
        ...routes.map(route => route.path),
        "/bulk/campaigns",
        "/schedule-calendar",
        "/companylist",
        "/announcements",
        "/campaigns",
        "/policy",
        "/scenario",
        "/gamification-engine/award-log",
        "/campaigns/schedule",
        "/announcements/schedule",
        "/policy/schedule"
      ];
      this.setHelpIconRoutes(helps_route);
    }
  },
};
</script>



// WEBPACK FOOTER //
// navbar.vue?47e82278